import { createContext } from 'react';

export const DraftModeContext = createContext(false);
